import React, { useState, useEffect } from 'react';
import SablonKarti from './SablonKarti';

const SablonListesi = ({ sablonlar, onDuzenle, onSil }) => {
  // Aynı anda yalnızca tek kart arkası dönük olur
  const [acikKartId, setAcikKartId] = useState(null);

  // Liste (ör. sayfa veya filtre) değiştiğinde çevrilen kartı sıfırla
  useEffect(() => {
    setAcikKartId(null);
  }, [sablonlar]);

  const toggleKart = (id) => {
    setAcikKartId(prev => (prev === id ? null : id));
  };

  if (!sablonlar || sablonlar.length === 0) {
    return (
      <div className="app-card-muted flex flex-col items-center justify-center py-16 text-center">
        <p className="font-display text-lg font-semibold text-slate-700">Şablon bulunamadı</p>
        <p className="mt-1 text-sm text-slate-500">Filtreleri değiştirin veya yeni bir şablon ekleyin.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3">
      {sablonlar.map(sablon => (
        <SablonKarti
          key={sablon.id}
          sablon={sablon}
          isBack={acikKartId === sablon.id}
          onToggleBack={toggleKart}
          onClick={() => onDuzenle(sablon)}
          onDelete={() => onSil(sablon.id)}
        />
      ))}
    </div>
  );
};

export default SablonListesi;
